import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import * as bie from "react-bootstrap";
import { config } from "../CommonUtils/CommonURLS";
import { FaEdit } from "react-icons/fa";
import * as Yup from "yup";
import { RiDeleteBin2Line } from "react-icons/ri";

// Hooks & Components
import { useRusaMasterData } from "./hooks/useRusaMasterData";
import { useRusaFormSubmit } from "./hooks/useRusaFormSubmit";
import {
  WorkDetailsSelect,
  OtherWorkInput,
  ProgressSelect,
  StartDateInput,
  EndDateInput,
  PercentageCompletionInput,
  PresentStatusInput,
  GeoTaggedPhotoInput,
  FacilityInUseRadio,
  BriefDescriptionInput,
  VideoLinkInput,
  CompNameCell,
} from "./components/RusaFormFields";
import { useEffect, useState } from "react";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { currentMonth, currentYear } from "../CommonUtils/CommonServices";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { viewImage } from "../CommonUtils/viewImage";
import { BsEyeFill } from "react-icons/bs";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import allowNumbersOnly from "../CommonUtils/CommonValidations";
import Swal from "sweetalert2";

const Renovation = () => {
  const { worksList } = useRusaMasterData();
  const { submitForm } = useRusaFormSubmit();

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const valueOrNull = (v) =>
    v !== "" && v !== undefined && v !== null ? v : null;
  const validationSchema = Yup.object({
    rusaPhase: Yup.string().required(ERROR_MSG).nullable(),
    constructionType: Yup.string().required(ERROR_MSG).nullable(),
    otherWork: Yup.string().when("constructionType", {
      is: "99",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    noOfUnitsConstructed: Yup.string().required(ERROR_MSG).nullable(),
    progressOfWork: Yup.string().required(ERROR_MSG).nullable(),
    compId: Yup.string().required(ERROR_MSG).nullable(),


    percentageOfCompletion: Yup.string().when("progressOfWork", {
      is: "ongoing",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    geoTaggedPhotos: Yup.string().when("progressOfWork", {
      is: (val) => val === "ongoing" || val === "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),


    presentStatus: Yup.string().when("progressOfWork", {
      is: "ongoing",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),




    startDate: Yup.string().when("progressOfWork", {
      is: (val) => val === "ongoing" || val === "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),

    dateOfCompletion: Yup.string().when("progressOfWork", {
      is: (val) => val === "ongoing" || val === "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),


    videoLinks: Yup.string().when("progressOfWork", {
      is: "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    briefDesc: Yup.string().when("progressOfWork", {
      is: "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    wetherUsing: Yup.string().when("progressOfWork", {
      is: "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),

  });
  const formik = useFormik({
    initialValues: {
      rusaPhase: "",
      constructionType: "",
      noOfUnitsConstructed: "",
      progressOfWork: "",
      otherWork: "",
      compId: "",
      startDate: "",
      dateOfCompletion: "",
      percentageOfCompletion: "",
      presentStatus: "",
      geoTaggedPhotos: '',

      wetherUsing: "",
      briefDesc: "",
      videoLinks: "",
    },
    validationSchema,

    onSubmit: (val) => {
      console.log("FORM VALUES 👉", val);

      const editing = isEdit;   // ✅ capture edit state

      const payload = {
        scheme: valueOrNull(val.rusaPhase),
        compType: "2",
        compId: valueOrNull(val.compId),
        constructionType: valueOrNull(val.constructionType),
        otherWork: valueOrNull(val.otherWork),
        noOfUnitsConstructed: valueOrNull(val.noOfUnitsConstructed),
        progressOfWork: valueOrNull(val.progressOfWork),
        startDate: valueOrNull(val.startDate),
        dateOfCompletion: valueOrNull(val.dateOfCompletion),
        percOfCompletion: valueOrNull(val.percentageOfCompletion),
        status: valueOrNull(val.presentStatus),
        constructionPhoto: valueOrNull(val.geoTaggedPhotos),
        facilityUtilised: valueOrNull(val.wetherUsing),
        briefDescription: valueOrNull(val.briefDesc),
        videoLink: valueOrNull(val.videoLinks),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        subEquipId: "",
        conductedAt: "",
        activityStatus: "",
        noOfParticipate: "",
        uploadActivityReport: "",
      };

      // ✅ Dynamic API
      const apiUrl = editing
        ? `${config.url.API_URL}updateInfraWorks?sno=${editId}`
        : `${config.url.API_URL}saveRusaInfradtls`;

      // ✅ Dynamic confirmation text
      const confirmText = editing
        ? "Are you sure you want to update?"
        : "Are you sure you want to submit?";

      // ✅ Submit
      submitForm(
        payload,
        () => {
          console.log("✅ Submit success → refreshing data");

          // ✅ Always refresh after save & edit
          GetRennivationData();

          formik.resetForm();
          setIsEdit(false);
          setEditId(null);
        },
        apiUrl,
        confirmText
      );
    }


  });

  const [component, setComponent] = useState([]);
  const [phasename, setPhasename] = useState([]);

  function GetComponentData(phase) {

    console.log("GetComponentData called with phase:", phase);
    if (!phase) return;
    const url = `${config.url.API_URL}getRusaComponentList?rusa_phase=${phase}`;
    CommonAxiosGet(url).then((res) => {
      setComponent(res?.data?.scode === "01" ? res.data.data : []);
    });

  }
  function GetRennoScheme() {
    const url = `${config.url.API_URL}getPhase`;
    CommonAxiosGet(url).then((res) => {
      setPhasename(res?.data?.scode === "01" ? res.data.phase : []);
    });
  }
  const ReportColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },

    {
      id: "scheme",
      header: "Scheme",
      accessorKey: "scheme",
    },

    {
      id: "comp_name",
      header: "Component Name",
      accessorKey: "comp_name",
      // size: 1300, // adjust width in pixels
      // cell: ({ row }) => {
      //   const Comp = row.original.comp_name;
      //   const otherWork = row.original.otherwork;
      //   return (
      //     <div style={{ minWidth: '250px', whiteSpace: 'normal' }}>
      //       {Comp && Comp.trim() !== "" ? Comp : otherWork}
      //     </div>
      //   );
      // },
      cell: CompNameCell
    },

    {
      id: "sub_comp_name_works",
      header: "Details Of Work",
      accessorKey: "sub_comp_name_works",

      cell: ({ row }) => {
        const Construction = row.original.construction_type;
        const otherWork = row.original.otherwork;
        const subcompname = row.original.sub_comp_name_works;

        return (
          <div className="text-start">
            {Construction === "99" ? otherWork : subcompname}
          </div>
        );
      },
    },
    {
      id: "no_of_units_constructed",
      header: "Number of Units / Nature of Work",
      accessorKey: "no_of_units_constructed",
    },
    {
      id: "progress_of_work",
      header: "Progress Of Work",
      accessorKey: "progress_of_work",
    },

    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
    },
    {
      id: "date_of_completion",
      header: "Date of Completion",
      accessorKey: "date_of_completion",
    },

    {
      id: "perc_of_completion",
      header: " Percentage of Completion",
      accessorKey: "perc_of_completion",
    },



    {
      id: "status",
      header: "Present Status",
      accessorKey: "status",
    },

    {
      id: "facility_utilised",
      header: "Whether Facility is in Use",
      accessorKey: "facility_utilised",
    },


    {
      id: "brief_description",
      header: "Brief description",
      accessorKey: "brief_description",
    },



    {
      id: "video_link",
      header: "Video Link",
      accessorKey: "video_link",


    },

    {
      id: "construction_photo",
      header: "Geo-Tagged Photo",
      accessorKey: "construction_photo",
      cell: ({ row }) => {
        const fileUrl = row.original?.construction_photo;

        if (!fileUrl) return null;

        return (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="View File"
            onClick={() => viewImage(fileUrl)}
          >
            <BsEyeFill size={18} />
          </button>
        );
      },
    },
    /* ================= EDIT / DELETE ================= */
    {
      id: "actions", // ✅ mandatory
      header: "Edit / Delete",
      cell: ({ row }) => {
        const rowData = row.original;

        return (
          <div className="d-flex gap-2">
            {/* ✏️ EDIT */}
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => {
                formik.setValues({
                  rusaPhase: rowData?.scheme,
                  constructionType: rowData?.construction_type,
                  noOfUnitsConstructed: rowData?.no_of_units_constructed,
                  progressOfWork: rowData?.progress_of_work,
                  otherWork: rowData?.otherwork,
                  // compId: (rowData?.comp_id),
                  compId: rowData?.comp_id,

                  startDate: rowData?.start_date,
                  dateOfCompletion: rowData?.date_of_completion,
                  percentageOfCompletion: rowData?.perc_of_completion,
                  presentStatus: rowData?.status,

                  wetherUsing: rowData?.facility_utilised,
                  briefDesc: rowData?.brief_description,
                  geoTaggedPhotos: rowData?.construction_photo,
                  videoLinks: rowData?.video_link,
                });

                GetComponentData(rowData?.scheme);
                setIsEdit(true);
                setEditId(rowData?.sno);
              }}
            >
              <FaEdit size={16} />
            </button>

            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => {
                Swal.fire({
                  title: "Are you sure?",
                  text: "Do you want to delete this record?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, delete it!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    const url = `${config.url.API_URL}deleteInfraWorks?sno=${rowData?.sno}`;
                    CommonAxiosPost(url)
                      .then((res) => {
                        if (res?.data?.scode === "01") {
                          Swal.fire(res?.data?.sdesc, "", "success");
                          GetRennivationData();
                        } else {
                          Swal.fire("Delete failed", "", "error");
                        }
                      })

                  }
                });
              }}
            >
              <RiDeleteBin2Line

                size={20} />
            </button>
          </div>
        );
      },
    },

  ];

  const [rennovdata, setRennovdata] = useState([]);
  function GetRennivationData() {
    let url = `${config.url.API_URL}getInfraWorksRen?month=${currentMonth}&year=${currentYear}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01" &&
        res?.data?.["ren"]?.length > 0) {
        setRennovdata(res.data["ren"]); // ✅ correct
      } else {
        setRennovdata([]);
      }
    });
  }

  useEffect(() => {
    GetRennoScheme();
    GetRennivationData();

  }, [])


  const ongoingClearFields = [
    "startDate",
    "dateOfCompletion",
    "percentageOfCompletion",
    "presentStatus",
    "geoTaggedPhotos"

  ];

  const completedClearFields = [
    "startDate",
    "dateOfCompletion",
    "wetherUsing",
    "geoTaggedPhotos",
    "briefDesc",
    "videoLinks"

  ];
  return (
    <bie.Container fluid className="px-0">
      <bie.Container className="px-0 pt-3 mw-100 pb-5">

        <div className="overal-stathead">
          <span>Renovation</span>
        </div>
        <FormikProvider value={formik}>
          <Form>
            <bie.Row className="g-3">
              <bie.Col lg={4}>
                <label htmlFor="Scheme">Scheme</label>
                <Field as="select" name="rusaPhase" className="form-control"
                  onChange={(e) => {
                    formik.handleChange(e);        // ✅ update Formik state
                    GetComponentData(e.target.value); // ✅ your custom logic
                  }}
                >
                  <option value="">--select--</option>
                  {phasename?.map((p) => (
                    <option key={p.rusa_phase} value={p.rusa_phase}>
                      {p.rusa_phase}
                    </option>
                  ))}


                </Field>
                <ErrorMessage name="rusaPhase" component="div" className="text-danger" />

              </bie.Col>

              {/* Component */}
              <bie.Col lg={4}>
                <label htmlFor="component">Component</label>
                <Field as="select" name="compId" className="form-control" >
                  <option value="">--select--</option>

                  {component?.map((c) => (
                    <option key={c.comp_id} value={c.comp_id}>
                      {c.component_name}
                    </option>
                  ))}

                </Field>
                <ErrorMessage name="compId" component="div" className="text-danger" />

              </bie.Col>

              <WorkDetailsSelect
                works={worksList?.renov}
                name="constructionType"
                label="Details of Work"
                onChange={(e) => {
                  formik.handleChange(e);

                  if (e.target.value !== "99") {
                    formik.setFieldValue("otherWork", "");
                  }
                }}
              />



              {formik?.values?.constructionType === "99" && <OtherWorkInput />}

              {/* <NoOfUnitsInput /> */}
              <bie.Col lg={4}>
                <label>No of Units/ Nature of Work </label>
                <Field type="text" name="noOfUnitsConstructed" maxLength={5} onKeyPress={allowNumbersOnly}
                  className="form-control" />
                <ErrorMessage name="noOfUnitsConstructed" component="div" className="text-danger" />

              </bie.Col>

              {/* <ProgressSelect /> */}
              <ProgressSelect
                formik={formik}
                ongoingClearFields={ongoingClearFields}
                completedClearFields={completedClearFields}
              />
              {/* ONGOING */}
              {formik.values.progressOfWork === "ongoing" && (
                <>
                  <StartDateInput />
                  <EndDateInput />
                  <PercentageCompletionInput />
                  <PresentStatusInput />
                  <GeoTaggedPhotoInput name="geoTaggedPhotos" formik={formik} />
                </>
              )}

              {/* COMPLETED */}
              {formik.values.progressOfWork === "completed" && (
                <>
                  <FacilityInUseRadio />
                  <StartDateInput name="startDate" />
                  {/* <EndDateInput name="endDate2" /> */}
                  <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                    <label htmlFor="Date of Completion " className="mb-1"> Date of Completion </label>
                    <Field type="date" name="dateOfCompletion" className="form-control" />
                    <ErrorMessage name="dateOfCompletion" component="div" className="text-danger" />
                  </bie.Col>

                  <BriefDescriptionInput />
                  <GeoTaggedPhotoInput name="geoTaggedPhotos" formik={formik} />
                  <VideoLinkInput />
                </>
              )}
            </bie.Row>

            <div className="text-end mt-3">
              <button type="submit" className="btn btn-success">
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>

            {rennovdata?.length > 0 && (
              <>


                <div className="overal-stathead">
                  <span>  Rennovation Report</span>
                </div>
                <div className="all-table-content">
                  <div className="table-responsive mt--40">
                    <CommonReactTable
                      data={rennovdata}
                      columns={ReportColumns}
                      filename="Rennovation Report"
                      headerName="Rennovation Report"
                      showFooter={true}
                      showPagination={false}
                    />
                  </div>
                </div>
              </>
            )}

          </Form>
        </FormikProvider>
      </bie.Container>
    </bie.Container>
  );
};

export default Renovation;
